import angular from 'angular';

import angularAnimate from 'angular-animate';

import angularFilter from 'angular-filter';

import angularSanitize from 'angular-sanitize';

import angularUIRouter from '@uirouter/angularjs';

import geneseNotification from '@advise/genese-notification';

import ngDeviceDetector from 'ng-device-detector';

import ngMaterial from 'angular-material';

export default angular.module('advise', [
	angularAnimate,
	angularFilter,
	angularSanitize,
	angularUIRouter,
	geneseNotification,
	ngDeviceDetector,
	ngMaterial
]);
